import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CourseService } from '@app/_services/course.service';
import { first } from 'rxjs/operators';

@Component({ templateUrl: 'course.component.html' })
export class CourseComponent implements OnInit {
    
    loading = false;
    courseId:any;
    course:any;

    constructor(private route: ActivatedRoute, private router: Router, private courseService: CourseService) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.courseId = params.get('id');
            this.getCourseContinue();
        });
    }

    getCourseContinue() {
        this.courseService.getCourseContinue(this.courseId).pipe(first()).subscribe(progressResponse => {
            this.loading = false;

            if(progressResponse.isIntro)
                this.router.navigate(['/course-intro', progressResponse.sectionId ]);
            else
                this.router.navigate(['/course-topic', progressResponse.sectionId ]);
        });
    }
}